import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useRef, useEffect } from "react";
import { useTranslation } from "@i18n";
import Markdown from "markdown-to-jsx";
import { twMerge } from "tailwind-merge";
import { replaceTextWithCurrencySymbols } from "@/_MiniApps/CurrencyFont/CurrencyFontProvider";
import Lottie from "lottie-react";
import colorfulConfettiAnimation from "@/common/lottie/ColorfulConfettiBrust.json";
export default function WarrantyCollapsedHeader(_ref) {
  var warrantyPriceDetails = _ref.warrantyPriceDetails,
    warranty_promo_code_enabled = _ref.warranty_promo_code_enabled,
    freeValueClassName = _ref.freeValueClassName;
  var _useTranslation = useTranslation(["web_checkout_cash"]),
    tShort = _useTranslation.tShort;
  var _ref2 = warrantyPriceDetails !== null && warrantyPriceDetails !== void 0 ? warrantyPriceDetails : {},
    title = _ref2.title,
    price = _ref2.price,
    is_free = _ref2.is_free,
    highlight_background = _ref2.highlight_background,
    text_color = _ref2.text_color;

  // Don't render if price data isn't ready yet
  if (!price) return null;

  // Refs for currency symbol replacement
  var freeRef = useRef(null);
  var currentRef = useRef(null);
  var originalRef = useRef(null);
  useEffect(function () {
    if (freeRef.current && price !== null && price !== void 0 && price.current_formatted) {
      replaceTextWithCurrencySymbols(price.current_formatted, freeRef.current);
    }
  }, [price === null || price === void 0 ? void 0 : price.current_formatted]);
  useEffect(function () {
    if (currentRef.current && price !== null && price !== void 0 && price.current_formatted) {
      replaceTextWithCurrencySymbols(price.current_formatted, currentRef.current);
    }
  }, [price === null || price === void 0 ? void 0 : price.current_formatted]);
  useEffect(function () {
    if (originalRef.current && price !== null && price !== void 0 && price.original_formatted) {
      replaceTextWithCurrencySymbols(price.original_formatted, originalRef.current);
    }
  }, [price === null || price === void 0 ? void 0 : price.original_formatted]);
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between w-full gap-2 pt-1"
  }, title && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center flex-wrap min-w-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] text-[14px] font-medium leading-snug ml-1"
  }, tShort("warranty/car_warranty_label", {
    ns: "web_checkout_cash"
  })), /*#__PURE__*/React.createElement(Markdown, {
    className: twMerge("rounded px-1 text-[14px] leading-snug"),
    style: _objectSpread(_objectSpread({}, highlight_background ? {
      backgroundColor: highlight_background
    } : {}), text_color ? {
      color: text_color
    } : {})
  }, title), warranty_promo_code_enabled && /*#__PURE__*/React.createElement(Lottie, {
    animationData: colorfulConfettiAnimation,
    loop: true,
    className: "w-8 h-8 shrink-0"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 flex-shrink-0 flex-row-reverse"
  }, is_free ? /*#__PURE__*/React.createElement("span", {
    className: twMerge("font-bold text-[16px] leading-tight", warranty_promo_code_enabled ? "text-[#00B362]" : "text-[#6d7a8d] pe-1", freeValueClassName)
  }, price === null || price === void 0 ? void 0 : price.current_formatted) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5"
  }, /*#__PURE__*/React.createElement("span", {
    ref: currentRef,
    className: twMerge("font-bold text-[16px] leading-tight", warranty_promo_code_enabled ? "text-[#00B362]" : "text-[#484848]")
  }, price === null || price === void 0 ? void 0 : price.current_formatted)), !!(price !== null && price !== void 0 && price.original) && price.original > price.current && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-0.5 opacity-70"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#6d7a8d] text-[14px] leading-tight"
  }, /*#__PURE__*/React.createElement(Markdown, {
    ref: originalRef,
    className: "strike-adjust-wrap"
  }, price === null || price === void 0 ? void 0 : price.original_formatted))))));
}